

import React, { Component } from "react";
import Slider from "react-slick";
import './../assets/css/video.css';
import { BASEURL } from "../../Global";

class VideoTestimonial extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentSlide: 0,
            testimonials: [],
            isLoading: true, // Add a loading state
        };
    }

    handleAfterChange = (current) => {
        this.setState({ currentSlide: current });
    };

    componentDidMount() {
        this.GetVideoTestimonialsNoAuth();
    }

    async GetVideoTestimonialsNoAuth() {
        try {
            const response = await fetch(`${BASEURL}/videotestimonialswithoutauth`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                },
            });

            const data = await response.json();
            if (data) {
                // Convert video URLs to embed URLs
                const testimonials = data.data.map(item => ({
                    ...item,
                    video_url: this.convertToEmbedUrl(item.video_url),
                }));

                this.setState({
                    testimonials: testimonials,
                    isLoading: false, // Set loading to false when data is fetched
                });
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            this.setState({ isLoading: false }); // Set loading to false even if there's an error
        }
    }

    convertToEmbedUrl(url) {
        const videoIdMatch = url.match(/(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
        if (videoIdMatch && videoIdMatch[1]) {
            return `https://www.youtube.com/embed/${videoIdMatch[1]}`;
        }
        return url;
    }

    render() {
        const { currentSlide, testimonials, isLoading } = this.state;

        const SampleNextArrow = (props) => {
            const { onClick } = props;
            return (
                <button onClick={onClick} type="button" className="slick-next slick-arrow">
                    <i className="fal fa-arrow-right"></i>
                </button>
            );
        };

        const SamplePrevArrow = (props) => {
            const { onClick } = props;
            return (
                <button onClick={onClick} type="button" className="slick-prev slick-arrow">
                    <i className="fal fa-arrow-left"></i>
                </button>
            );
        };

        const settings = {
            dots: false,
            infinite: false, // Disable infinite scrolling
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            nextArrow: <SampleNextArrow />,
            prevArrow: <SamplePrevArrow />,
            initialSlide: 0,
            waitForAnimate: false,
            autoplay: false,
            autoplaySpeed: 2000,
            afterChange: this.handleAfterChange,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: false, // Disable infinite scrolling
                        dots: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        initialSlide: 1,
                        infinite: false, // Disable infinite scrolling
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: false, // Disable infinite scrolling
                    }
                }
            ]
        };

        return (
            <React.Fragment>
                <section className="bg-smoke-blue space-extra">
                    <div className="container">
                        <div className="row gy-30 align-items-center">
                            <div className="col-lg-6 wow fadeInLeft" data-wow-delay="0.1s" style={{ padding: '0px 10% 0px 0px' }}>
                                <div className="text-center text-lg-start">
                                    <span className="sub-title">Video Testimonial</span>
                                    <h2 className="sec-title">Positive Video Review Of Us</h2>
                                    {/* <p className="mb-30">Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum Lorem Ipsum .</p> */}
                                </div>
                            </div>

                            <div className="col-lg-6 slider-wrapper wow fadeInRight" data-wow-delay="0.1s">
                                {isLoading ? (
                                    <p>Loading testimonials...</p>
                                ) : (
                                    <Slider {...settings}>
                                        {testimonials.map((item, index) => (
                                            <div key={index} className="team-box">
                                                <div className="">
                                                    <iframe
                                                        width="100%"
                                                        height="500"
                                                        src={item.video_url}
                                                        title="YouTube video player"
                                                        frameBorder="0"
                                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                        allowFullScreen
                                                    ></iframe>
                                                </div>
                                            </div>
                                        ))}
                                    </Slider>
                                )}
                            </div>
                        </div>
                    </div>
                </section>
            </React.Fragment>
        );
    }
}

export default VideoTestimonial;

